/**
 * Australian jurisdictions used by the medicolegal Code of Conduct
 * section. Kept as a single source of truth so Case Creation, the
 * Update Case modal, and the Report Builder's CoC pre-select logic
 * all agree on the slug.
 *
 * The slug is what's stored on `Case.jurisdiction` server-side and
 * matches the `tickBoxItem.value` / `option_choices.choices` key used
 * by the Report Builder templates.
 *
 * This is the interim shape — once the Vinci profile lookup ships,
 * the doctor's location will populate `Case.jurisdiction` automatically
 * and the user-facing select will go away.
 */
export type JurisdictionSlug =
  | "nsw"
  | "vic"
  | "qld"
  | "sa"
  | "wa"
  | "tas"
  | "nt"
  | "act"
  | "federal";

export type JurisdictionOption = {
  value: JurisdictionSlug;
  label: string;
};

export const JURISDICTIONS: JurisdictionOption[] = [
  { value: "nsw", label: "New South Wales" },
  { value: "vic", label: "Victoria" },
  { value: "qld", label: "Queensland" },
  { value: "sa", label: "South Australia" },
  { value: "wa", label: "Western Australia" },
  { value: "tas", label: "Tasmania" },
  { value: "nt", label: "Northern Territory" },
  { value: "act", label: "Australian Capital Territory" },
  { value: "federal", label: "National - Federal Court" },
];

export const getJurisdictionLabel = (slug: string | null | undefined): string =>
  JURISDICTIONS.find((j) => j.value === slug)?.label ?? "";
